import { getCurrentApiEnvironment } from './store/environment.store'

export const getApiEnvironment = (): 'live' | 'dev' => {
    return getCurrentApiEnvironment()
}

const ALLOWED_COUNTRIES = ['thailand', 'oman', 'kuwait', 'singapore', 'taiwan'] as const
type AllowedCountry = (typeof ALLOWED_COUNTRIES)[number]
type PaymentResponseStatus = 'success' | 'failed'

const isAllowedCountry = (s: string): s is AllowedCountry => (ALLOWED_COUNTRIES as readonly string[]).includes(s)

export const getBasePath = (): string => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean)

    // Find country wherever it sits in the path (handles /oman/ and /feature/branch/oman/)
    const countryIndex = pathSegments.findIndex(segment => isAllowedCountry(segment))
    if (countryIndex !== -1) {
        return '/' + pathSegments.slice(0, countryIndex + 1).join('/')
    }

    if (import.meta.env.PROD) {
        return `/${pathSegments[0] || 'thailand'}`
    }

    return ''
}

export const getCountryFromPath = (): string => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean)

    // Find country wherever it sits in the path (handles /oman/ and /feature/branch/oman/)
    const country = pathSegments.find(segment => isAllowedCountry(segment))
    if (country) return country

    if (import.meta.env.PROD) {
        return pathSegments[0] || 'thailand'
    }

    // Dev fallback: ?country= query param
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('country') || 'thailand'
}

export const getFullPath = (path: string): string => {
    const basePath = getBasePath()
    return `${basePath}${path}`
}

export const getPaymentResponseUrl = (status: PaymentResponseStatus): string => {
    return `${window.location.origin}${getFullPath(`/payment-response/${status}`)}`
}

export const getPaymentResponseGatewayUrls = () => ({
    gateway_success_url: getPaymentResponseUrl('success'),
    gateway_error_url: getPaymentResponseUrl('failed')
})
